module.exports = __webpack_public_path__ + "img/play-phone-en.66c6367a.png";